<template>
  <div class="groupRules">
    <b-row class="mb-4">
      <b-col cols="12">
        <span>
          <strong> Als... </strong>
        </span>

        <ol class="px-4 pt-4 mb-2">
          <li
            class="group-rule"
            v-for="(rule, index) in rules"
            :key="`group-rule-${index}`"
          >
            <b-row>
              <b-col
                cols="12"
                class="
                  d-flex
                  flex-row
                  col-12
                  align-items-center
                  justify-content-between
                "
              >
                <span>
                  <GroupRule :rule="rule" />
                  <span v-if="index !== rules.length - 1">, en...</span>
                </span>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>
            </b-row>
          </li>
        </ol>

        <span>
          <strong> ...dan wordt de order op hold gezet. </strong>
        </span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import GroupRule from "./GroupRule.vue";
export default {
  name: "GroupRules",
  props: {
    rules: {
      type: Array,
      required: true,
    },
  },
  components: { GroupRule },
};
</script>